import { useCallback, useEffect, useRef, useState } from 'react'
import { Icone } from './Icone'

/**
 * Le bandeau de confirmation — TRANSPOSITION de `toast()`.
 *
 * L'original gardait son minuteur dans `window._tt`. Ici il vit dans une
 * référence : deux messages rapprochés ne peuvent plus se voler leur minuteur,
 * et le nettoyage au démontage est garanti.
 */
export function useNotification() {
  const [message, setMessage] = useState<string | null>(null)
  const minuteur = useRef<ReturnType<typeof setTimeout> | null>(null)

  const notifier = useCallback((m: string) => {
    setMessage(m)
    if (minuteur.current) clearTimeout(minuteur.current)
    minuteur.current = setTimeout(() => setMessage(null), 2600)
  }, [])

  useEffect(() => () => {
    if (minuteur.current) clearTimeout(minuteur.current)
  }, [])

  const bandeau = (
    <div className={`toast${message ? ' on' : ''}`} id="toast">
      <span className="tk">
        <Icone nom="spark" />
      </span>{' '}
      <span id="toast-msg">{message}</span>
    </div>
  )

  return { notifier, bandeau }
}
